import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAllAssignedProjects = createAsyncThunk(
    'assigneProjects/fetchAllAssignedProjects',
    async ({userUID})=>{
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/fetchAssigne-projects/${userUID}`);
        return response.data;
    }
)
export const fetchSentAssignedProjects = createAsyncThunk(
    'assigneProjects/fetchSentAssignedProjects',
    async (userUID)=>{
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/fetchAssigne-send-projects/${userUID}`);
        return response.data;
    }
)

export const fetchReceiveAssignedProjects = createAsyncThunk(
    'assigneProjects/fetchReceiveAssignedProjects',
    async (userUID)=>{
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/fetchAssigne-inbox-projects/${userUID}`);
        return response.data;
    }
)

const AssigneProjectsReducer = createSlice({
    name:'assigneProjects',
    initialState:{
        allAssigneData:{clients:[]},
        sentAssignedData:{client:[]},
        receiveAssignedData:{client:[]},
        status:'idle',
        error:null,
    },
    reducers:{},
    extraReducers: (builder)=>{
        builder
        .addCase(fetchAllAssignedProjects.pending, (state)=>{
            state.status='loading';
        })
        .addCase(fetchAllAssignedProjects.fulfilled,(state,action)=>{
            state.status='succeeded';
            state.allAssigneData= action.payload;
        })
        .addCase(fetchAllAssignedProjects.rejected,(state ,action)=>{
            state.status='failed';
            state.error = action.error.message;
        })
        .addCase(fetchSentAssignedProjects.pending, (state)=>{
            state.status='loading';
        })
        .addCase(fetchSentAssignedProjects.fulfilled,(state,action)=>{
            state.status='succeeded';
            state.sentAssignedData= action.payload;
        })
        .addCase(fetchSentAssignedProjects.rejected,(state ,action)=>{
            state.status='failed';
            state.error = action.error.message;
        })
        .addCase(fetchReceiveAssignedProjects.pending, (state)=>{
            state.status='loading';
        })
        .addCase(fetchReceiveAssignedProjects.fulfilled,(state,action)=>{
            state.status='succeeded';
            state.receiveAssignedData= action.payload;
        })
        .addCase(fetchReceiveAssignedProjects.rejected,(state ,action)=>{
            state.status='failed';
            state.error = action.error.message;
        })
    }
})

export default AssigneProjectsReducer.reducer